import React, {createContext, useState} from "react";
import PMSQuickListItemServices from "../../services/pms_services/PMSQuickListItemServices";
import Notification from "../../components/common/Notification";

export const PMSQuickListItemContext = createContext("PMSQuickListItemContext");

const PMSQuickListItemContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [quickListItems, setQuickListItems] = useState([]);
    const [total, setTotal] = useState(0);

    const handleError = (error) => {
        setLoading(false);
        let _error = "Something went wrong.";
        if (error.message === "Network Error") _error = error.message;
        if (error.response && error.response.data) _error = error.response.data.message;
        setErrorMsg(_error);
        Notification("error", "ERROR", `${_error}`);
        return false;
    };

    const getAll = async (quickListId, pharmacyId, params = {}) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSQuickListItemServices.getAll(quickListId, pharmacyId, params);
            setQuickListItems(res.data.content || []);
            setTotal(res.data.totalElements || 0);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const create = async (quickListId, pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSQuickListItemServices.create(quickListId, pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Item added successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const update = async (id, quickListId, pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSQuickListItemServices.update(id, quickListId, pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Item updated successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const deleteItem = async (id, quickListId, pharmacyId) => {
        try {
            setLoading(true);
            await PMSQuickListItemServices.delete(id, quickListId, pharmacyId);
            setLoading(false);
            Notification("success", "SUCCESS", "Item deleted successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    return (
        <PMSQuickListItemContext.Provider
            value={{
                loading,
                errorMsg,
                quickListItems,
                total,
                getAll,
                create,
                update,
                deleteItem,
            }}
        >
            {children}
        </PMSQuickListItemContext.Provider>
    );
};

export default PMSQuickListItemContextProvider;
